<ng-container *ngIf="!preview; else showListNotificationsInPreview">
    <div class="btn" (click)="openNotifications()" [class.unread]="hasUnreadNotifications">
        <svg-image name="notifications"></svg-image>
    </div>

    <div class="notifications__overlay" [ngClass]="{visible: isNotificationVisible}" (click)="isNotificationVisible = false"></div>
    <div class="notifications" [ngClass]="{visible: isNotificationVisible}">
        <!--  Tabs will be here  -->
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
</ng-container>

<ng-template #showListNotificationsInPreview>
    <div class="notification__list">
        <div class="notification__item notification__item--banner">
            <div class="notification__link">
                <div class="notification__message txt-sm">
                    <div class="notification__message-banner" [innerHTML]="previewContent"></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #content>
    <ng-container *ngIf="Boolean(notifications.length); else empty" [ngTemplateOutlet]="notificationsList"></ng-container>
    <ng-template #empty>
        <ng-container [ngTemplateOutlet]="emptyList"></ng-container>
    </ng-template>
</ng-template>

<ng-template #notificationsList>
    <div #notificationListElem class="notification__list" [class.block-loading]="loadingPage || loading" (scroll)="onScrollLoadData()">
        <ng-container *ngFor="let node of notifications; trackBy: trackById">
            <div
                class="notification__item"
                [ngClass]="notificationBackground$ | async"
                [class.notification__item--banner]="notificationBanner$ | async"
                [class.notification__item--can-deleted]="node.canBeDeleted"
                [class.notification__item--seen]="node.isRead"
            >
                <ng-container [ngTemplateOutlet]="notificationMessage" [ngTemplateOutletContext]="{$implicit: node}"></ng-container>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #notificationMessage let-node>
    <div class="notification__link">
        <notification-banner
            [backgroundType$]="notificationBackground$"
            [isBanner]="notificationBanner$"
            [node]="node"
            (watch)="watchNotification($event.event, $event.node)"
            (removeItem)="deleteNotification($event)"
        ></notification-banner>
        <div class="notification__time txt-sm">{{ formattingDate(node.createdAt) }}</div>
    </div>
</ng-template>

<ng-template #emptyList>
    <empty-state [emptyFullPage]="true" [iconName]="'info'">
        <h4 class="title-h4">{{ 'notifications.emptyList.title' | i18next }}</h4>
        <p class="txt-sm">{{ 'notifications.emptyList.text' | i18next }}</p>
    </empty-state>
</ng-template>
